import { reviewImages } from '@/lib/media';

// ── Real, verified Oferteo reviews (rating 5.0/5) ────────────────────────────
// Single source of truth for the review data — consumed by the client
// TestimonialsSection (rendered, SSR'd into the HTML). Deliberately NOT marked
// up as Review/AggregateRating JSON-LD: Google treats reviews a business shows
// about itself as "self-serving" — ineligible for stars and a manual-action
// risk. Star ratings belong on the Google Business Profile. Do not re-add.
// `text` is the ORIGINAL language (`lang`); the Translate toggle swaps in the
// per-locale copy from the i18n `testimonials.r{id}` keys at runtime.
export interface Review {
  id: number;
  initial: string;
  lang: string;
  score: number;
  text: string;
  images: string[];
}

export const REVIEWS: Review[] = [
  {
    id: 0,
    initial: 'S.',
    lang: 'pl',
    score: 5,
    text:
      'Bardzo profesjonalne wykonanie kontakt i całe podejście do pracy. Duża dbałość o szczegóły oraz świetne doradztwo. Najlepszy wybór materiałów i zero pójścia na skróty. Pierwsze co mnie osobiście urzekło w podejściu Serhija i ekipy to to, że po zrozumieniu że będą pracowali w domu o konstrukcji szkieletowej wykonali szereg testów na ścianie z płytami wykończeniowymi, taśmami i gładziami do ich łączenia po to żeby sprawdzić co w tych warunkach w praktyce zadziała najlepiej. Polecam ich podejście i fachowość wykonanej pracy.',
    images: reviewImages.S,
  },
  {
    id: 1,
    initial: 'M.G.',
    lang: 'pl',
    score: 5,
    text:
      'Jestem architektem wnętrz, a Panowie wykańczali u mnie dwie łazienki oraz schody. Z czystym sumieniem mogę potwierdzić, że sprostali dużym wymaganiom :)) łazienki były mocno skomplikowane. Robota jest wykonana precyzyjnie, nawet kanały do zrzutu prania zostały starannie wykonane wg moich wytycznych. Co ważne czytają rysunki, a jeśli coś trzeba wykonać inaczej niż w projekcie - to zawsze pytają. Taka współpraca to na 5 👍',
    images: [],
  },
  {
    id: 2,
    initial: 'M.',
    lang: 'pl',
    score: 5,
    text:
      'Firma realizowała wykończenie naszego domu pod Warszawą, ca. 250m² w okresie lipiec–wrzesień 2025. Ekipa stawiła się na czas, wykonała prace w terminie jak określony w umowie. W kwestii techniki wykonania i jakości – bez zarzutu. Gładzie i malowanie uratowały nasze nierówne tynki. Miła współpraca, nie ma rzeczy, których „się nie da zrobić”. Ewentualne małe błędy były naprawiane bez zbędnego „ale”.',
    images: reviewImages.M,
  },
  {
    id: 3,
    initial: 'A.',
    lang: 'pl',
    score: 5,
    text:
      'Panowie wykonali moją łazienkę od A do Z – profesjonalnie, solidnie i terminowo. Efekt przerósł moje oczekiwania! Zdecydowanie polecam tę ekipę.',
    images: [],
  },
  {
    id: 4,
    initial: 'E.',
    lang: 'pl',
    score: 5,
    text:
      'Bardzo dziękuję za świetnie wykonaną pracę! Łazienka została zrobiona nawet lepiej, niż się spodziewałem – w dużej mierze dzięki poradom doświadczonych fachowców. Ściany zostały otynkowane i pomalowane szybko i sprawnie, bez żadnych zastrzeżeń. Wszystko to w rozsądnej cenie – dlatego z pełnym przekonaniem polecam tę ekipę!',
    images: reviewImages.E,
  },
  {
    id: 5,
    initial: 'A.',
    lang: 'pl',
    score: 5,
    text:
      'Ekipa naprawdę super. Panowie kompetentni, dokładni i bardzo terminowi. Usługa wykonana dokładnie zgodnie z oczekiwaniami i odebrana bez żadnych zastrzeżeń. Bardzo polecam tą firmę jeżeli zależy Wam na profesjonalnym i terminowym wykonaniu remontu!',
    images: [],
  },
  {
    id: 6,
    initial: 'T.',
    lang: 'pl',
    score: 5,
    text:
      'Gorąco polecam. Wyremontowali dwa pokoje szybko i sprawnie, tak jak chcieliśmy, w samą porę na nasze wakacje.',
    images: [],
  },
];

// Aggregate figures for the on-page trust badge only (no schema markup — see above).
export const REVIEWS_COUNT = REVIEWS.length;
export const REVIEWS_BEST_RATING = 5;
export const REVIEWS_AVG_RATING =
  Math.round((REVIEWS.reduce((sum, r) => sum + r.score, 0) / REVIEWS.length) * 10) / 10;
